import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HealthComponent } from './components/health/health.component';

export const routes: Routes = [
  
  {
    path: '',
    loadChildren: () => import('./views/layout/layout.module').then(m => m.LayoutModule),
  },
  { 
    path: 'not-found',
    loadChildren: () => import('./views/not-found/not-found.module').then(m => m.NotFoundModule) 
  },
  { 
    path: 'market-place',
    loadChildren: () => import('./views/market-place/market-place.module').then(m => m.MarketPlaceModule) 
  },
  { path: 'healthcheck', component: HealthComponent },
  { 
    path: '**', 
    redirectTo: 'not-found' 
  },
  

];
  
@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})

export class AppRoutingModule { }
